<template>
  <div class="error-box grid gap-2 rounded-lg p-3">
    <p class="error-text">{{ message }}</p>
    <ul v-if="details.length" class="error-details list-disc pl-5 error-text">
      <li v-for="item in details" :key="item">{{ item }}</li>
    </ul>
    <pre v-if="debug" class="error-debug overflow-x-auto rounded-lg p-2 text-xs leading-5">{{ debug }}</pre>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    message: string
    details?: string[]
    debug?: string
  }>(),
  { details: () => [], debug: '' },
)
</script>

<style scoped lang="scss">
.error-box {
  border: 1px solid var(--color-danger-emphasis);
  background-color: var(--color-danger-subtle);
}

// Spacing is owned by the list, not the items - a grid/gap here would strip the
// list markers, since grid items lose display: list-item.
.error-details > li + li {
  margin-top: 4px;
}

.error-debug {
  border: 1px solid var(--color-border-default);
  background-color: var(--color-canvas-default);
  color: var(--color-danger-on-subtle);
}
</style>
